import { render, staticRenderFns } from "./ShowSecondAddressCustomerProfile.vue?vue&type=template&id=068b550c"
import script from "./ShowSecondAddressCustomerProfile.vue?vue&type=script&lang=js"
export * from "./ShowSecondAddressCustomerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports